import type { SxProps, Theme } from "@mui/material";
import type React from "react";
import { useAuth } from "@/contexts/AuthProvider";
import { isHeadNurse } from "@/utils/utilFunctions";
import { AdminUpdatesBell } from "../scheduleChanges/bellPanel/AdminUpdatesBell";
import { StaffNotificationBell } from "./StaffNotificationBell";

interface NotificationBellProps {
	color?: "inherit" | "primary" | "secondary" | "default";
	size?: "small" | "medium" | "large";
	sx?: SxProps<Theme>;
}

/**
 * The header bell. Admins get the Updates side panel (schedule changes + requests waiting for a decision); staff keep
 * the notifications page. Two components so each side's hooks run only for its own audience.
 */
export const NotificationBell: React.FC<NotificationBellProps> = ({ color = "inherit", size = "small", sx = {} }) => {
	const { userInfo } = useAuth();
	return isHeadNurse(userInfo.role) ? <AdminUpdatesBell color={color} size={size} sx={sx} /> : <StaffNotificationBell color={color} size={size} sx={sx} />;
};
